export class PublicChargeSubscriptionDto {
  chargingStationId: string

  /**
   * The actual charging point database index, not the connector id.
   */
  chargingPointId: number
  parkOwnerName: string
  parkOwnerStripeAccountId: string
  stripePriceId: string
  stripePaymentIntentId?: string
  stripeClientSecret?: string
  
  email: string
  method: string
  
  cardnumber?: string
  expirationdate?: string
  security?: string
  cardOwner?: string

  iban?: string
  accountOwner?: string

  company: string
  name: string
  street: string
  housenumber: string
  postcode: string
  city: string
  country: string

  maxAmount?: number
}
